module.exports = __webpack_public_path__ + "static/media/infoIcon.ed2dec09.svg";